import QRCode from 'react-qr-code';
import AccentureLogo from '../resources/images/AccentureLogo';
import HeaderBackground from '../resources/images/HeaderBackground.png';
import HeaderBackground2 from '../resources/images/HeaderBackground2.png';

interface HeaderProps {
  qrCodeURL: string;
}

function ItineraryHeader({ qrCodeURL }: HeaderProps) {
  return (
    <div className="h-full w-full px-3 pt-5">
      <div
        className={`Header  flex min-h-[176px] w-full  items-center justify-start gap-3 bg-cover bg-center pl-8 sm:pb-3.5 sm:pt-3 md:h-[250px] md:justify-between md:py-16 md:pl-24 md:pr-8 bg-[${HeaderBackground}]`}
        style={{ backgroundImage: `url(${HeaderBackground2})` }}
      >
        <div className="Frame22  inline-flex flex-col items-start justify-start gap-2">
          <div className="Frame18 inline-flex h-5 w-36 items-start justify-start gap-4">
            <div className="AccentureLogo1 relative h-5 w-20">
              <AccentureLogo />
            </div>
          </div>
          <div className="YourItinerary max-w-[367px] font-['Graphik'] text-3xl font-semibold text-white md:text-7xl">
            Your Itinerary
          </div>
        </div>
        <div className="Frame19 hidden max-h-[150px] min-h-36 max-w-[318px] items-center  justify-center gap-2.5 rounded-3xl border border-white border-opacity-30 bg-neutral-400 bg-opacity-20 p-4 backdrop-blur-3xl md:flex">
          <div className="Frame20 inline-flex shrink grow basis-0 flex-col items-center justify-center gap-4">
            <div className="WantToTakeYourItineraryWithYou self-stretch font-['Graphik'] text-base font-semibold leading-tight text-white">
              Want to take your itinerary with you?
            </div>
            <div className="ScanWithYourPhoneToDownload self-stretch font-['Graphik'] text-sm font-normal leading-none text-white">
              Scan with your phone to download
            </div>
          </div>
          <div className="QrCodeExample1 relative h-28 w-28">
            <QRCode
              size={256}
              style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
              value={qrCodeURL}
              viewBox={`0 0 256 256`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ItineraryHeader;
